import { QuestionSubmission } from '../models/question-submission.model';
import { QuizLifecycleState } from '../models/quiz-lifecycle.enum';
import { QuizQuestion } from '../models/quiz-question.model';
import { QuizSettingsModel } from '../models/quiz-settings.model';
import { QuizPickMode, QuizStateModel } from './quiz.state';

export namespace QuizActions {

  export class SetQuizState {
    static readonly type = '[Quiz] Set Quiz State';
    constructor(public quizState: Partial<QuizStateModel>) {}
  }

  export class ResetQuizState {
    static readonly type = '[Quiz] Reset Quiz State';
    constructor() {}
  }

  export class SetQuizSettings {
    static readonly type = '[Quiz] Set Quiz Settings';
    constructor(public quizSettings: QuizSettingsModel) {}
  }

  export class SetQuizActive {
    static readonly type = '[Quiz] Set Quiz Active';
    constructor(public active: boolean) {}
  }

  export class SetQuizEnabled {
    static readonly type = '[Quiz] Set Quiz Enabled';
    constructor(public enabled: boolean) {}
  }

  export class SetQuizLocked {
    static readonly type = '[Quiz] Set Quiz Locked';
    constructor(public locked: boolean) {}
  }

  export class SetQuizQuestionsMode {
    static readonly type = '[Quiz] Set Quiz Questions Mode';
    constructor(public mode: 'all' | 'restricted') {}
  }

  export class CopyQuestions {
    static readonly type = '[Quiz] Copy Quiz Questions';
    constructor(public sourceChapterId: string, public targetChapterId: string) {}
  }

  export class ReorderQuestions {
    static readonly type = '[Quiz] Reoder Quiz Questions';
    constructor(public chapterIds: string[]) {}
  }

  export class AddQuestion {
    static readonly type = '[Quiz] Add Quiz Question';
    constructor(public question: QuizQuestion) {}
  }

  export class DeleteQuestion {
    static readonly type = '[Quiz] Delete Quiz Question';
    constructor(public id: QuizQuestion['id']) {}
  }

  export class SetQuestions {
    static readonly type = '[Quiz] Set Quiz Questions';
    constructor(public questions: QuizQuestion[]) {}
  }

  export class SetQuestion {
    static readonly type = '[Quiz] Set Quiz Question';
    constructor(public question: QuizQuestion) {}
  }

  export class SubmitQuestionAnswer {
    static readonly type = '[Quiz] Submit Question Answer';
    constructor(public submission: QuestionSubmission) {}
  }

  export class NextQuestion {
    static readonly type = '[Quiz] Advance Question';
    constructor() {}
  }


  export class PreviousQuestion {
    static readonly type = '[Quiz] Previous Question';
    constructor() {}
  }

  export class ClearSubmissions {
    static readonly type = '[Quiz] Clear Submissions';
    constructor() {}
  }

  export class SetActiveQuestion {
    static readonly type = '[Quiz] Set Active Question';
    constructor(public questionId: string) {}
  }

  export class SetQuizPickMode {
    static readonly type = '[Quiz] Set Pick Mode';
    constructor(public pickMode: QuizPickMode) {}
  }

  export class SetActiveSubmission {
    static readonly type = '[Quiz] Set Active QuestionAnswer';
    constructor(public submission: QuestionSubmission) { }
  }

  export class SetQuizLifecycle {
    static readonly type = '[Quiz] Set Quiz Lifecycle';
    constructor(public lifecycle: QuizLifecycleState) { }
  }
}
